import { useRef, useEffect, useState } from 'react';
import { getActiveState } from '../helpers/titreHelper';
import { useGetParams } from './useGetParams';
import { useInterval } from './useInterval';

export const useVote = () => {
  const { user } = useGetParams();

  const currentStateRef = useRef(null);
  const isVisibleRef = useRef(null);
  const [voteState, setVoteState] = useState(null);

  const protocol = window?.location.protocol || 'https:';

  const keyRef = useRef(false);

  const getVoteInfo = async () => {
    try {
      if (!user) {
        return;
      }
      const response = await fetch(
        `${protocol}//stream.iactive.pro/scr/getPollInfo.php?user=${user}`,
        { cache: 'no-store' },
      );
      const data = await response.json();
      if (!data) return;

      let { visibility } = data;

      // Определяем видимость титра
      const isVisible = Boolean(Number(visibility));

      if (!isVisible && isVisible !== isVisibleRef.current) {
        isVisibleRef.current = false;
      } else if (isVisible && isVisible !== isVisibleRef.current) {
        isVisibleRef.current = true;
      }
      // Определяем состояние (S1, S2 ...)

      if (
        data?.state &&
        getActiveState(data?.state) !== currentStateRef.current
      ) {
        // для игнорирования анимации перехода между S1 и S2
        if (
          currentStateRef.current === 'S1' &&
          getActiveState(data?.state) === 'S2'
        ) {
        } else if (
          currentStateRef.current === 'S2' &&
          getActiveState(data?.state) === 'S1'
        ) {
        } else {
          keyRef.current = getActiveState(data?.state);
        }

        currentStateRef.current = getActiveState(data?.state);
      }
      setVoteState(data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getVoteInfo();
  }, []);

  useInterval(() => {
    getVoteInfo();
  }, 1000);

  return {
    currentState: currentStateRef.current,
    isVisible: isVisibleRef.current,
    voteState,
    keyRef: keyRef.current,
  };
};
